// extracted by mini-css-extract-plugin
export default {"tableHeadersContainer":"styles_tableHeadersContainer__JIFEp","tech":"styles_tech__aMcp+","timeSlot":"styles_timeSlot__MCnA2","headerText":"styles_headerText__6+Y6W"};